// panel nawigacyjny
export const NAV_PANEL_CLOSE = 'APP_CONFIG/NAV_PANEL_CLOSE';
export const NAV_PANEL_TOGGLE = 'APP_CONFIG/NAV_PANEL_TOGGLE';

// język aplikacji
export const LANGUAGE_SET = 'APP_CONFIG/LANGUAGE_SET';

// ustawienie maintenance mode
export const MAINTENANCE_MODE_SET = 'APP_CONFIG/MAINTENANCE_MODE_SET';

// protokoły
export const PROTOCOL_MODAL_OPEN = 'APP_CONFIG/PROTOCOL_MODAL_OPEN';
export const PROTOCOL_MODAL_CLOSE = 'APP_CONFIG/PROTOCOL_MODAL_CLOSE';

export const PROTOCOL_GENERATE_SINGLE_START = 'APP_CONFIG/PROTOCOL_GENERATE_SINGLE_START';
export const PROTOCOL_GENERATE_SINGLE_SUCCESS = 'APP_CONFIG/PROTOCOL_GENERATE_SINGLE_SUCCESS';
export const PROTOCOL_GENERATE_SINGLE_FAIL = 'APP_CONFIG/PROTOCOL_GENERATE_SINGLE_FAIL';

export const PROTOCOL_GENERATE_GROUP_START = 'APP_CONFIG/PROTOCOL_GENERATE_GROUP_START';
export const PROTOCOL_GENERATE_GROUP_SUCCESS = 'APP_CONFIG/PROTOCOL_GENERATE_GROUP_SUCCESS';
export const PROTOCOL_GENERATE_GROUP_FAIL = 'APP_CONFIG/PROTOCOL_GENERATE_GROUP_FAIL';

export const PROTOCOL_GET_STATUS_START = 'APP_CONFIG/PROTOCOL_GET_STATUS_START';
export const PROTOCOL_GET_STATUS_SUCCESS = 'APP_CONFIG/PROTOCOL_GET_STATUS_SUCCESS';
export const PROTOCOL_GET_STATUS_FAIL = 'APP_CONFIG/PROTOCOL_GET_STATUS_FAIL';

export const PROTOCOL_PDF_GET_START = 'APP_CONFIG/PROTOCOL_PDF_GET_START';
export const PROTOCOL_PDF_GET_SUCCESS = 'APP_CONFIG/PROTOCOL_PDF_GET_SUCCESS';
export const PROTOCOL_PDF_GET_FAIL = 'APP_CONFIG/PROTOCOL_PDF_GET_FAIL';

export const PROTOCOL_PDF_DOWNLOAD_START = 'APP_CONFIG/PROTOCOL_PDF_DOWNLOAD_START';
export const PROTOCOL_PDF_DOWNLOAD_SUCCESS = 'APP_CONFIG/PROTOCOL_PDF_DOWNLOAD_SUCCESS';
export const PROTOCOL_PDF_DOWNLOAD_FAIL = 'APP_CONFIG/PROTOCOL_PDF_DOWNLOAD_FAIL';

export const PROTOCOL_PDF_PRINT_OUT_START = 'APP_CONFIG/PROTOCOL_PDF_PRINT_OUT_START';
export const PROTOCOL_PDF_PRINT_OUT_SUCCESS = 'APP_CONFIG/PROTOCOL_PDF_PRINT_OUT_SUCCESS';
export const PROTOCOL_PDF_PRINT_OUT_FAIL = 'APP_CONFIG/PROTOCOL_PDF_PRINT_OUT_FAIL';

// historia ocen
export const CHANGE_LOG_MODAL_OPEN = 'APP_CONFIG/CHANGE_LOG_MODAL_OPEN';
export const CHANGE_LOG_MODAL_CLOSE = 'APP_CONFIG/CHANGE_LOG_MODAL_CLOSE';

export const CHANGE_LOG_DATA_GET_SUCCESS = 'APP_CONFIG/CHANGE_LOG_DATA_GET_SUCCESS';
export const CHANGE_LOG_DATA_GET_FAIL = 'APP_CONFIG/CHANGE_LOG_DATA_GET_FAIL';

// parowanie efektów
export const PAIR_EFFECTS_MODAL_OPEN = 'APP_CONFIG/OPEN_PAIR_EFFECTS_MODAL_OPEN';
export const PAIR_EFFECTS_MODAL_CLOSE = 'APP_CONFIG/CLOSE_PAIR_EFFECTS_MODAL_CLOSE';

export const PAIR_EFFECTS_SAVE_START = 'APP_CONFIG/PAIR_EFFECTS_SAVE_START';
export const PAIR_EFFECTS_SAVE_FAIL = 'APP_CONFIG/PAIR_EFFECTS_SAVE_FAIL';

export const PAIR_EFFECTS_SELECT_CARD_LANGUAGE = 'APP_CONFIG/PAIR_EFFECTS_SELECT_CARD_LANGUAGE';
export const PAIR_EFFECTS_SELECT_CARD_VERSION = 'APP_CONFIG/PAIR_EFFECTS_SELECT_CARD_VERSION';

export const PAIR_EFFECTS_SELECT_STUDY_PROGRAM = 'APP_CONFIG/PAIR_EFFECTS_SELECT_STUDY_PROGRAM';
export const PAIR_EFFECTS_GET_STUDY_PROGRAMS = 'APP_CONFIG/PAIR_EFFECTS_GET_STUDY_PROGRAMS';
export const PAIR_EFFECTS_GET_STUDY_PROGRAMS_SUCCESS = 'APP_CONFIG/PAIR_EFFECTS_GET_STUDY_PROGRAMS_SUCCESS';
export const PAIR_EFFECTS_GET_STUDY_PROGRAMS_FAIL = 'APP_CONFIG/PAIR_EFFECTS_GET_STUDY_PROGRAMS_FAIL';

export const CHANGE_SELECT_PROGRAM_OPEN = 'APP_CONFIG/CHANGE_SELECT_PROGRAM_OPEN';

export const PAIR_EFFECTS_GET_LEARNING_EFFECTS_START = 'APP_CONFIG/PAIR_EFFECTS_GET_LEARNING_EFFECTS_START';
export const PAIR_EFFECTS_GET_LEARNING_EFFECTS_SUCCESS = 'APP_CONFIG/PAIR_EFFECTS_GET_LEARNING_EFFECTS_SUCCESS';
export const PAIR_EFFECTS_GET_LEARNING_EFFECTS_FAIL = 'APP_CONFIG/PAIR_EFFECTS_GET_LEARNING_EFFECTS_FAIL';

export const PAIR_EFFECTS_GET_ALREADY_PAIRED_EFFECTS_START = 'APP_CONFIG/PAIR_EFFECTS_GET_ALREADY_PAIRED_EFFECTS_START';
export const PAIR_EFFECTS_GET_ALREADY_PAIRED_EFFECTS_SUCCESS = 'APP_CONFIG/PAIR_EFFECTS_GET_ALREADY_PAIRED_EFFECTS_SUCCESS';
export const PAIR_EFFECTS_GET_ALREADY_PAIRED_EFFECTS_FAIL = 'APP_CONFIG/PAIR_EFFECTS_GET_ALREADY_PAIRED_EFFECTS_FAIL';

export const PAIR_EFFECTS_SELECT_LEARNING_EFFECTS = 'APP_CONFIG/PAIR_EFFECTS_SELECT_LEARNING_EFFECTS';

// Wybór realizatorów przedmiotu
export const REALIZATORZY_MODAL_OPEN = 'APP_CONFIG/REALIZATORZY_MODALL_OPEN';
export const REALIZATORZY_MODAL_CLOSE = 'APP_CONFIG/REALIZATORZY_MODAL_CLOSE';

export const REALIZATORZY_GET_LIST_SUCCESS = 'APP_CONFIG/REALIZATORZY_GET_LIST_SUCCESS';
export const REALIZATORZY_GET_LIST_FAIL = 'APP_CONFIG/REALIZATORZY_GET_LIST_FAIL';
export const REALIZATORZY_SELECT = 'APP_CONFIG/REALIZATORZY_SELECT';

// Kopiowanie danych z innej karty przedmiotu
export const COPY_SUBJECT_CARD_MODAL_OPEN = 'APP_CONFIG/OPEN_COPY_SUBJECT_CARD_MODAL_OPEN';
export const COPY_SUBJECT_CARD_MODAL_CLOSE = 'APP_CONFIG/CLOSE_COPY_SUBJECT_CARD_MODAL_CLOSE';

export const COPY_SUBJECT_CARD_GET_LIST_START = 'COPY_SUBJECT_CARD_GET_LIST_START';
export const COPY_SUBJECT_CARD_GET_LIST_SUCCESS = 'COPY_SUBJECT_CARD_GET_LIST_SUCCESS';
export const COPY_SUBJECT_CARD_GET_LIST_FAIL = 'COPY_SUBJECT_CARD_GET_LIST_FAIL';

export const COPY_SUBJECT_CARD_START = 'COPY_SUBJECT_CARD_START';
export const COPY_SUBJECT_CARD_SUCCESS = 'COPY_SUBJECT_CARD_SUCCESS';
export const COPY_SUBJECT_CARD_FAIL = 'COPY_SUBJECT_CARD_FAIL';

export const COPY_SUBJECT_CARD_SELECT = 'COPY_SUBJECT_CARD_SELECT';
export const COPY_SUBJECT_CARD_SET_SEARCH = 'COPY_SUBJECT_CARD_SET_SEARCH';

// przepisywanie ocen końcowych na podstawie ocen wyliczonych
export const COPY_FINAL_MARKS_MODAL_OPEN = 'OPEN_COPY_FINAL_MARKS_MODAL_CLOSE';
export const COPY_FINAL_MARKS_MODAL_CLOSE = 'CLOSE_COPY_FINAL_MARKS_MODAL_CLOSE';

export const COPY_FINAL_MARKS_MODAL_GET_STUDENTS = 'COPY_FINAL_MARKS_MODAL_GET_STUDENTS';
export const COPY_FINAL_MARKS_MODAL_SET_STUDENTS_IN_STATE = 'COPY_FINAL_MARKS_MODAL_SET_STUDENTS_IN_STATE';
export const COPY_FINAL_MARKS_MODAL_SET_PRZEDMIOT_IN_STATE = 'COPY_FINAL_MARKS_MODAL_SET_PRZEDMIOT_IN_STATE';

export const COPY_FINAL_MARKS_FAIL = 'COPY_FINAL_MARKS_FAIL';

// przeniesienie do panelu admina
export const REDIRECT_TO_ADMIN_PANEL = 'REDIRECT_TO_ADMIN_PANEL';

// zapytanie o status api
export const CHECK_API_STATUS = 'CHECK_API_STATUS';
export const CHECK_API_STATUS_FINISH = 'CHECK_API_STATUS_FINISH';

// notyfikacje z panelu admina
export const GET_NOTIFICATION_LIST_ADMIN = 'GET_NOTIFICATION_LIST_ADMIN';
export const GET_NOTIFICATION_LIST_ADMIN_FINISH = 'GET_NOTIFICATION_LIST_ADMIN_FINISH';
